import type { MedplumClient } from "@medplum/core";
import { useCallback, useState } from "react";
import { parseAccessPolicy } from "../lib/parse-permissions";
import type { Permissions } from "../types";

export function usePermissionsState(medplum: MedplumClient, initial: Permissions) {
  const [permissions, setPermissions] = useState(initial);

  const refetch = useCallback(async () => {
    const membership = medplum.getProjectMembership();
    const isProjectAdmin = membership?.admin ?? false;

    try {
      const authMe = await medplum.get("auth/me");
      if (authMe.accessPolicy) {
        setPermissions(parseAccessPolicy(authMe.accessPolicy, isProjectAdmin));
      } else {
        setPermissions(parseAccessPolicy(null, isProjectAdmin));
      }
    } catch {
      // Fetch failed, reset to no access
      setPermissions(parseAccessPolicy(null, false));
    }
  }, [medplum]);

  const clear = useCallback(() => {
    setPermissions(parseAccessPolicy(null, false));
  }, []);

  return { permissions, refetch, clear };
}
